import React, { Component, PropTypes } from 'react';
import ModalHeader from 'components/ModalClose/ModalHeader';
import classNames from 'classnames';

export default class ModalClose extends Component {
  static propTypes = {
    open: PropTypes.bool,
    bodyClass:PropTypes.string,
    headerComponent: PropTypes.node,
    contentComponent: PropTypes.node,
    footerComponent: PropTypes.node,
    onCloseModal: PropTypes.func.isRequired,
    productCardFlag: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
    singleColumn: PropTypes.bool,
  };

  render() {
    const { open, parentClass, bodyClass, headerComponent, contentComponent, footerComponent, onCloseModal, productCardFlag, hideCloseButton } = this.props;

    return (
      <div className={ classNames('modalclose', { open }, { [`${parentClass}`]: open }) } onClick={ hideCloseButton ? onCloseModal : null}>
        {
          (productCardFlag || hideCloseButton) ? null :
            <div className='close-icon'>
              <i className='material-icons pointer' onClick={ onCloseModal } >clear</i>
            </div>
        }
        <div className={ classNames('modalclose-body', { [`${ bodyClass || 'modalclose-body-show-default' }`]: open }, this.props.singleColumn ? 'single-column' : null) }>

          <div className='modal-header'>
            { headerComponent || null }
          </div>
          <div className='modal-content'>
            { contentComponent || null }
          </div>
          <div className='modal-footer'>
            { footerComponent || null }
          </div>
        </div>
      </div>
    );
  }
}

export { ModalHeader };